<template>
  <div>
    <SetupWhitelisted v-if="hasRequiredParams" />

    <List v-else />
  </div>
</template>

<script>
import List from './List.vue'
import SetupWhitelisted from './SetupWhitelisted.vue'

export default {
  name: 'SetupWhitelistedIndex',
  components: {
    List,
    SetupWhitelisted,
  },
  computed: {
    /**
     * Check if both id and platform parameters are present in the URL
     * @returns {boolean} True if both id and platform exist in query params
     */
    hasRequiredParams() {
      const { id, platform } = this.$route.query
      return !!(id && platform)
    },
  },
  watch: {
    /**
     * Watch for route changes to update the component display
     */
    '$route.query': {
      handler() {
        // Force component re-evaluation when query params change
        this.$forceUpdate()
      },
      deep: true,
    },
  },
  mounted() {
    // Fetch pending count on initial load
    this.$store.dispatch('komadsWhitelist/fetchPendingCount')
  },
}
</script>

<style scoped>
/* No specific styling needed for this wrapper component */
</style>
